import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import RatingStars from 'components/RatingStars';
import { bem } from 'helpers/class-name';

import './RatingsStarsReview.scss';

const { block, element, modifier } = bem('ratings-stars-review');

export const RatingsStarsReview = ({ rating, timePassed, size = 'md' }) => {
  return (
    <div className={classNames(block(), modifier(size))}>
      <RatingStars className={element('stars')} quantity={rating} />
      <time>{timePassed}</time>
    </div>
  );
};

RatingsStarsReview.propTypes = {
  rating: PropTypes.number.isRequired,
  timePassed: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md']),
};
